export default __webpack_public_path__ + "static/media/new-pause.13adeb47.svg";